



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,Minus,Paperclip,Plus,X} from 'lucide-react';

  
const QuestionCardLoading=()=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    


    
     useEffect(()=>{
     
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
    
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<>
  
   <div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"10px",marginBottom:"10px",padding:"10px",paddingBottom:"20px",paddingLeft:"10px",background:"#ffffff"}}>
<div className="courseContentItemJustifyContentIcons">
    <div  className="text-linetw " style={{padding:"4px",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}></div>
 </div><div className="courseContentItemJustifyContent"> 
    <div  className="text-linetw " style={{padding:"4px",height:"18px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}></div>
            </div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
           <div  className="text-linetw " style={{padding:"4px",height:"18px",width:"20px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}></div>
                  
        <div  className="text-linetw " style={{padding:"4px",height:"18px",width:"20px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}></div>
         </div>
        
 </div></>)
}  

export default QuestionCardLoading;
